import { render } from "./WikiComponent.vue?vue&type=template&id=5920c28c&scoped=true&ts=true"
import script from "./WikiComponent.vue?vue&type=script&lang=ts"
export * from "./WikiComponent.vue?vue&type=script&lang=ts"

import "./WikiComponent.vue?vue&type=style&index=0&id=5920c28c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5920c28c"]])

export default __exports__